import service from '../../utils/request'
import allUrl from "../../utils/setUrl"

//班级列表
export function classList(data){
  return service({
      url:allUrl.home+'/class/list',
      method:"post",
      data
  })
}

// 保存个人信息
export function saveData(data){
  return service({
      url:allUrl.home+'/student/save',
      method:"post",
      data
  })
}

// 保存个人信息
export function submitData(data){
  return service({
      url:allUrl.home+'student/submit',
      method:"post",
      data
  })
}



// 修改个人信息
export function updateData(data){
  return service({
      url:allUrl.home+'/student/update',
      method:"post",
      data
  })
}

// 通过ID查询信息
export function searchInfoData(id){
  return service({
      url:`${allUrl.home}student/info/${id}`,
      method:"get"
  })
}


//查询一级城市数据 
export function admindivisionFirstList(params){
  return service({
      url:allUrl.home+'/admindivision/firstList',
      method:"get",
      params
  })
}
//查询下面城市数据
export function admindivisionNextList(parentCode){
  return service({
      url:`${allUrl.home}/admindivision/list?parentCode=${parentCode}`,
      method:"post",
  })
}

// 通过分校-教学中心找专业
//获取所有分部/分校
export function industryCollegesList(params){
  return service({
    url: allUrl.home+ '/couschool/getBranchListByAreaName',
    method:"get",
    params
  })
}

//获取教学中心
export function getChildrensByParentId(params){
  return service({
    url: allUrl.home+ 'couschool/getDeclareCentersByAreaNameAndBranchId',
    method:"get",
    params
  })
}

// 通过专业找教学中心


// 通过机构ID查询当前学期培养方案
export function getTeachPlanBySchoolId(params){
  return service({
    url:allUrl.home+'/teachPlan/getTeachPlanBySchoolId',
    method:"post",
    params
  })
}
export function getTeachPlanBySchoolIdAndEducation(params){
  return service({
    url:allUrl.home+'/teachPlan/getTeachPlanBySchoolIdAndEducation',
    method:"post",
    params
  })
}

// 查询教学中心所有培养方案
export function getCollegeTeachPlanList(params){
  return service({
    url:allUrl.home+'/teachPlan/getCollegeTeachPlanList',
    method:"post",
    params
  })
}

// 查询所有专业列表
export function getSchoolSpecialtyByStatus(data){
  return service({
    url:allUrl.home+'/schoolSpecialty/getSchoolSpecialtyByStatus',
    method:"post",
    data
  })
}

// 通过专业id查询分校列表
export function getBranchListBySpecialtyId(params){
  return service({
    url:allUrl.home+'/couschool/getBranchListBySpecialtyId',
    method:"get",
    params
  })
}

// 通过分校id查询可以申报的教学中心
export function getDeclareCentersBySchoolId(params){
  return service({
    url:allUrl.home+'/couschool/getDeclareCentersByAreaNameAndBranchId',
    method:"get",
    params
  })
}

export function getSpecialty(data){
  return service({
    url:allUrl.home+'specialty/get',
    method:"post",
    data
  })
}

// 获取采集的照片
export function getPhotosByIdentityNum(params){
  return service({
    url:allUrl.home+'photos/getPhotosByIdentityNum',
    method:"get",
    params
  })
}
